import React, {Suspense} from 'react'
import {Route, Switch} from 'react-router-dom'

import PageLoader from '@progyny/components/PageLoader'
import {RouteEnum, useRoutes} from '@progyny/routes'

const MarketplaceHome = React.lazy(
  () => import('@progyny/pages/Marketplace/Home')
)
const MarketplacePartner = React.lazy(
  () => import('@progyny/pages/Marketplace/Partner')
)

const MarketplaceRoutes: React.FC = () => {
  const {getPath} = useRoutes()

  return (
    <Suspense fallback={<PageLoader position={'center'} />}>
      <Switch>
        <Route
          exact
          path={getPath(RouteEnum.MARKETPLACE)}
          component={MarketplaceHome}
        />
        <Route
          path={`${getPath(RouteEnum.MARKETPLACE)}/:slug`}
          component={MarketplacePartner}
        />
      </Switch>
    </Suspense>
  )
}

export default MarketplaceRoutes
